const settingsPage = {
  "settings.save.success": "Settings saved.",
  "settings.save.error": "Could not save your settings. Please try again.",
  'settings.page.title': 'Settings',
  'settings.page.section.profile': 'Profile',
  'settings.page.link.my-profile': 'My Profile',
  'settings.page.link.switch-profile': 'Switch Profile',
  'settings.page.link.members': 'Members',
  'settings.page.section.account': 'Account',
  'settings.page.section.general': 'General',
  'settings.page.section.admin': 'Admin',
  'settings.page.link.switch-account': 'Switch Account',
  'settings.page.link.privacy': 'Privacy',
  'settings.page.link.security': 'Security',
  'settings.page.link.help-and-support': 'Help & Support',
  'settings.page.link.about': 'About',
  'settings.page.link.super-admin': 'Super Admin',
  'settings.page.link.dev-settings': 'Dev Settings',
  'settings.page.section.system': 'System',
  'settings.page.link.display-and-graphics': 'Display and Graphics',
  'settings.page.link.audio': 'Audio',
  'settings.page.link.in-game-feedback': 'In-Game Feedback',
  'settings.page.link.controller': 'Controller',
  'settings.page.link.my-kit': 'My Kit',
  'settings.page.link.default-kit': 'Account Kit',
};

const membersPage = {
  'settings.members.title': 'Members',
  'settings.members.section.profiles': '{{ count }} profiles ({{ available }} available)',
  'settings.members.add-member': 'Add Member',
  'settings.members.invite-member': 'Invite User',
  'settings.members.invite-member.count': 'Invite User ({{ count }} remaining)',
  'settings.members.you': 'You',
  'settings.members.selected': '{{ count }} profiles selected',
  'settings.members.pending': 'Pending Invite',
  'settings.members.assign-role': 'Assign Role',
  'settings.members.delete': 'Delete',
  'settings.members.profiles-remaining': '{{ count }} Remaining',
  'settings.members.filter.members': 'Members',
  'settings.members.filter.invites': 'Invites',
  'settings.members.assign-role.title': 'Assign Role',
  'settings.members.assign-role.description': 'Adjust the role of the selected users.',
  'settings.members.assign-role.cancel': 'Cancel',
  'settings.members.assign-role.save': 'Save',
  'settings.members.delete.title': 'Delete members?',
  'settings.members.delete.description':
    'This action cannot be undone. The users will permanently be removed from your account.',
  'settings.member.delete.title': 'Delete member?',
  'settings.member.delete.description':
    'This action cannot be undone. The user will permanently be removed from your account.',
  'settings.members.profile-limit':
    'Your account has reached its profile limit. To invite more members, please upgrade your subscription.',
  'settings.members.pending-invites.title': 'Pending Invites',
  'settings.members.pending-invites.description':
    "You've been invited to join the following accounts. Accept an invite to gain access to the account.",
  'settings.members.pending-invites.accept': 'Accept',
  'settings.members.pending-invites.decline': 'Decline',
  'settings.members.invited-by': 'Invited by {{ name }}',
  'settings.members.invite.edit.title': 'Manage Invite',
  'settings.members.invite.edit.description': 'Pending invitation for {{ email }}',
  'settings.members.invite.edit.description.existing': 'Pending invitation for user {{ email }}',
  'settings.members.invite.edit.recipient': 'Recipient: {{ name }}',
  'settings.members.invite.resend': 'Resend',
  'settings.members.invite.delete': 'Delete',
};

const profilePage = {
  "settings.profile.title": "Profile",
  "settings.profile.title.alt": "Edit Member",
  "settings.profile.details": "Details",
  "settings.profile.details.first": "First name",
  "settings.profile.details.last": "Last name",
  "settings.profile.details.phone": "Phone number",
  "settings.profile.details.gender": "Gender",
  "settings.profile.details.role": "Role",
  "settings.profile.details.account-owner-warning": "Account owners roles cannot be changed here.",
  "settings.profile.preferences": "Preferences",
  "settings.profile.preferences.join-leaderboards": "Join Leaderboards",
  "settings.profile.preferences.anonymous-ranking": "Anonymous Ranking",
  "settings.profile.notifications": "Notifications",
};

const myKitPage = {
  "settings.my-kit.title": "My Kit",
  "settings.my-kit.section": "Customize your kit",
  "settings.my-kit.not-admin-warning": "Only admin roles or higher can customize the account kit.",
};

const defaultKitPage = {
  "settings.default-kit.title": "Account Kit",
  "settings.default-kit.section": "Customize your groups kit",
};

const audioPage = {
  "settings.audio.title": "Audio",
  "settings.audio.section": "Volume strength",
  "settings.audio.master": "Master volume",
  "settings.audio.music": "Music volume",
  "settings.audio.voice": "Voice volume",
  "settings.audio.crowd": "Crowd volume",
};

const feedbackPage = {
  "settings.feedback.title": "In-Game Feedback",
  "settings.feedback.section.text": "Show Text Feedback",
  "settings.feedback.section.voice": "Give Voice Feedback",
  "settings.feedback.text.critical": "Critical Scans",
  "settings.feedback.text.decisions": "Decisions",
  "settings.feedback.voice.scan-rate": "Scan Rate",
  "settings.feedback.voice.scan-timing": "Scan Timing",
  "settings.feedback.voice.critical": "Critical Scans",
  "settings.feedback.voice.awareness": "Awareness Tests",
  "settings.feedback.voice.decisions": "Decisions",
};

const controllerPage = {
  "settings.controller.title": "Controller",
  "settings.controller.section": "Controller Vibration",
  "settings.controller.haptic.strength": "Vibration strength",
};

const languageSettingsPage = {
  "settings.language.title": "Language Settings",
  "settings.language.section": "Language Preferences",
  "settings.language.select": "Select Language",
  "settings.page.link.language": "Language"
}
  
export const settings = {
  ...settingsPage,
  ...membersPage,
  ...profilePage,
  ...audioPage,
  ...myKitPage,
  ...defaultKitPage,
  ...feedbackPage,
  ...controllerPage,
  ...languageSettingsPage,
};
